import React from 'react'
import Webdevhero from '../../../Components/Webdev/Webdevhero'
import Webdevabout from '../../../Components/Webdev/Webdevabout'
import Webdevchooseus from '../../../Components/Webdev/Webdevchooseus'
import Webdevservices from '../../../Components/Webdev/Webdevservices'
import Webdevpricing from '../../../Components/Webdev/Webdevpricing'
import Projectform from '../../../Components/Projects/Projectform'
const Webdev = () => {
  return (
    <>
    <Webdevhero/>
    <Webdevabout/>
    <Webdevchooseus/>
    <Webdevservices/>
    <Webdevpricing/>
    <Projectform/>
    </>
  )
}

export default Webdev